// Global error handler for failed dynamic imports (chunk load failures)
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('Failed to fetch dynamically imported module')
  ) {
    // Optionally, show a message to the user
    window.location.reload(true); // Force reload from server
  }
});

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { AppProvider } from './modules/contexts/AppContexts.jsx'
import { ResourcesContextProvider } from './modules/contexts/ResourcesContext.jsx'
import { EventProvider } from './modules/contexts/EventContext.jsx'
import { VettingProvider } from './modules/contexts/VettingContext.tsx'
import { LanguageProvider } from './modules/contexts/LanguageContext.jsx'
import './i18n.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
        <LanguageProvider>
          <AppProvider>
            <EventProvider>
              <ResourcesContextProvider>
                <VettingProvider>
                  <App />
                </VettingProvider>
              </ResourcesContextProvider>
            </EventProvider>
          </AppProvider>
        </LanguageProvider>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
)
